import React from 'react';
import { cn } from '@lqa-frontend/ui-system';
import {
	LoadingAnimation,
	LoadingAnimationSize,
} from '../loader/LoadingAnimation';

export type ITableContainerProps = React.ComponentProps<'div'> & {
	isLoading?: boolean;
	loadingTestId?: string;
};

function TableContainer({
	className,
	children,
	isLoading = false,
	loadingTestId,
	...props
}: ITableContainerProps) {
	return (
		<div
			// `overflow-clip` instead of `overflow-hidden` so vertical wheel /
			// touchpad events on the table area pass through to the page
			// scroller. `hidden` establishes a scroll container that captures
			// wheel events even when there's nothing to scroll, which traps
			// page-level scroll when the cursor is over the table — symptom
			// scaled with row count (50 rows = unscrollable).
			className={cn(
				'relative flex w-full min-w-0 flex-col overflow-clip rounded-m border border-divider bg-base-1',
				className
			)}
			aria-busy={isLoading || undefined}
			data-slot="table-container-wrapper"
			data-testid="table-container-wrapper"
			data-loading={isLoading || undefined}
			{...props}
		>
			{children}
			{isLoading && (
				<div
					className="absolute inset-0 z-10 flex items-center justify-center bg-base-1/80"
					data-slot="table-loading-overlay"
					data-testid={loadingTestId ?? 'table-container-loading'}
				>
					<LoadingAnimation size={LoadingAnimationSize.Medium} />
				</div>
			)}
		</div>
	);
}

export { TableContainer };
